var render = function render(_c,_vm){return _c('div',{staticClass:"n-grid-2 n-grid-lg-1"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }